// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteDigitalAssetRequestModel from '../../model/delete-digital-asset-request-model';
import DeleteDigitalAssetRequestDTO from '../dto/delete-digital-asset-request-dto';
import dtoSchema from '../schemas/delete-digital-asset-request-schema';

export default abstract class DeleteDigitalAssetRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteDigitalAssetRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteDigitalAssetRequestDTO>): DeleteDigitalAssetRequestModel;
  static toModel(dto: DeepPartial<DeleteDigitalAssetRequestDTO> | undefined | null): DeleteDigitalAssetRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteDigitalAssetRequestDTO> | undefined | null): DeleteDigitalAssetRequestModel | undefined {
    return dto ? new DeleteDigitalAssetRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteDigitalAssetRequestModel> | DeleteDigitalAssetRequestModel): DeleteDigitalAssetRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteDigitalAssetRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteDigitalAssetRequestModel, can not map to DeleteDigitalAssetRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
